<template>
  <b-row>
    <div class="col-lg-4 col-md-4">
      <div class="bg-white rounded border p-3">
        <!-- Name -->
        <div class="d-flex flex-column ">
          <div class="d-flex flex-row mb-2 align-items-start">
            <div class="input-label">Slug:</div>
            <div v-if="slugEditEnabled" class="ms-2">
              <b-form-input v-model="requestSaveCategoryData.slug" :state="slugValidation()" class="me-3"
                            type="text" v-bind:class="{
                                    'form-control': true,
                                    'is-invalid': !slugValidation(),
                                }"/>
              <div class="invalid-feedback">
                Slug should not be empty!
              </div>
            </div>
            <div v-else class="me-1 px-1 py-1">
              /{{ requestSaveCategoryData.slug }}
            </div>
            <a v-if="slugEditEnabled == null || slugEditEnabled == false" class="" href="javascript:void(0)"
               style="padding-inline: 5px; padding-block: 1px;" type="button"
               @click="slugEditEnabled = true">
              <i class="fa-regular fa-pen-to-square text-primary"></i> Edit
            </a>
            <a v-else href="javascript:void(0)" style="padding-inline: 5px; padding-block: 1px;"
               @click="slugEditEnabled = false">
              <i class="fa-solid fa-xmark text-primary"></i>
              Cancel</a>
          </div>
          <label class=" input-label">Name *</label>
          <div class="userInputField">
            <b-form-input v-model="requestSaveCategoryData.name" class="form-control px-3 " placeholder="Add title"
                          style="height: 44px;" v-bind:class="{
                                'form-control': true,
                                'is-invalid': !nameValidation() && nameBlurred,
                            }" v-on:blur="nameBlurred = true"/>
            <!-- <span v-if="msg.name" class="text-danger px-1 mt-1">{{ msg.name }}</span> -->
            <div class="invalid-feedback">
              Name should not be empty!
            </div>
          </div>
        </div>
        <!--English Name -->
        <div class="userRole d-flex flex-column ">
          <label class="input-label">Name (English)</label>
          <input id="nameEnControlInput" v-model="requestSaveCategoryData.name_en"
                 class="form-control px-3 userInputField"
                 placeholder="Category Name in English" style="height: 44px;"
                 type="name"/>
        </div>

        <div class="userRole d-flex flex-column ">
          <label class="input-label">Type</label>
          <select v-model="requestSaveCategoryData.view_type"
                  class="form-control userInputField">
            <option :value="null" disabled selected>
              Choose a type...
            </option>
            <option value="REGULAR">
              Regular
            </option>
            <option value="LIST">
              List
            </option>
            <option value="CARD">
              Card
            </option>
          </select>
        </div>

        <!--Description -->
        <div class="userRole d-flex flex-column ">
          <label class="input-label">Description</label>

          <textarea id="DescriptionControlInput" v-model="requestSaveCategoryData.description"
                    class="form-control userInputField"
                    placeholder="Category Description" type="name"/>
        </div>

        <div class="userRole d-flex flex-column ">
          <label class="input-label">Status</label>

          <select v-model="requestSaveCategoryData.public_yn"
                  class="userInputField py-2 border rounded px-2">
            <option value="Y">Publish</option>
            <option value="N">Draft</option>
          </select>
        </div>

        <!--Position -->
        <div class="userRole d-flex flex-column ">
          <label class="input-label">Position</label>

          <input id="positionControlInput" v-model="requestSaveCategoryData.position"
                 class="form-control userInputField"
                 placeholder="Category Position" type="name"/>
        </div>
        <!-- image  -->
        <div v-if="category_id == 2" class="form-group">
          <label class="footerLabels">Category Logo</label>
          <!-- <input class="form-control" type="file" /> -->
          <div>
            <div class="d-flex justify-content-start">
              <button class="btn btn-light border border-dark" @click="showModalLogo = true">Add
                Logo
              </button>
            </div>
            <div v-if="showModalLogo">
              <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                   class="modal fade show" role="dialog" style="display: block;"
                   tabindex="-1">
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                      <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                              type="button" @click="showModalLogo = false"></button>
                    </div>
                    <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                      <select-logo @logoImg="getCategoryImage"/>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                              @click="showModalLogo = false">Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure class="figure mt-2">
              <div v-if="requestSaveCategoryData.image_url != null" class="border rounded">
                <img :src="imageBasePath + requestSaveCategoryData.image_url" alt="Subcategory Image"
                     height="100" style="object-fit: contain"
                     width="100">
              </div>
            </figure>
          </div>
        </div>
        <!-- submit -->
        <div v-if="permissions.UPDATE_CONTENT == 'Y' || permissions.ADD_CONTENT == 'Y'"
             class="d-flex flex-row mt-4">
          <button v-if="loading" class="btn btn-dark" disabled type="button">
            <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
            <span class="sr-only">Loading...</span>
          </button>
          <button v-else-if="!editEnabled && permissions.ADD_CONTENT == 'Y'" class="btn btn-primary" type="submit"
                  @click="addCategory">
            Add Category
          </button>
          <button v-else-if="editEnabled && permissions.UPDATE_CONTENT == 'Y'" class="btn btn-dark me-2"
                  type="submit" @click="updateCategory">
            Update
          </button>
          <button v-if="editEnabled" class="btn btn-danger" type="submit" @click="clearData">
            Cancel
          </button>
        </div>
        <div v-else class="text-danger ms-2 mt-2">
          You don't have the permission to add/edit categories.
        </div>
      </div>

    </div>
    <div class="col-lg-8 col-md-8 rounded border" style="background-color: white;">
      <div class="input-label p-3">All {{ elementName }} Categories</div>
      <!--      <div v-if="loading">-->
      <!--        <div class="d-flex justify-content-center">-->
      <!--          <div class="spinner-border " role=" status">-->
      <!--            <span class="visually-hidden">Loading...</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="p-3">
        <b-row>
          <b-col class="my-2 col-4 p-1" lg="3" md="4">
            <b-form-group class="mb-0 ms-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                             class="col-md-4" size="sm" @change="handlePageSizeChange"></b-form-select>
            </b-form-group>
          </b-col>
          <!--        search        -->
          <b-col class="my-2 col-4" lg="6" md="4"></b-col>
          <b-col class="my-2 col-4 p-1" lg="3" md="4">
            <div class="d-flex flex-row align-items-center">
              <b-input-group class="me-2" size="sm">
                <b-form-input id="filter-input" v-model="filter" placeholder="Type to Search"
                              type="search"></b-form-input>
              </b-input-group>
              <button class="rounded btn-info me-4" @click="onFiltered">Search</button>
            </div>
          </b-col>
        </b-row>
        <b-table :busy="loading" :fields="fields" :items="categories" bordered hover responsive striped>
          <template #cell(status)="row">
            <div v-if="row.item.public_yn === 'Y'">
              <b-badge variant="success">Published</b-badge>
            </div>
            <div v-else>
              <b-badge variant="danger">Draft</b-badge>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="d-flex flex-wrap gap-1 justify-content-center">
              <button v-if="permissions.UPDATE_CONTENT === 'Y'" class="btn btn-info btn-sm" title="Edit Category"
                      type="button" @click="beginEditing(row.item)">
                <i class="fa-regular fa-pen-to-square"></i>
              </button>
              <button v-if="permissions.DELETE_CONTENT === 'Y'" class="btn btn-danger btn-sm"
                      title="Unpublish Category" type="button" @click="unpublish(row.item.id)">
                <i class="fa-solid fa-trash-can"></i>
              </button>
            </div>
          </template>
        </b-table>
        <!--    Pagination            -->
        <b-row>
          <b-col class="mt-2" md="12" sm="12">
            <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center"
                          class="my-0" next-text="Next" prev-text="Prev" @click="handlePageChange"></b-pagination>
          </b-col>
        </b-row>
      </div>

    </div>
  </b-row>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import subcategoryService from "@/services/subCategory.service"
import Config from '@/config/index';
import selectLogo from '@/components/Media/SelectLogo.vue';

export default {
  name: "ElementCategories",
  props: ['category_id', 'elementName'],
  components: {
    "select-logo": selectLogo,
  },
  computed: {
    name() {
      return this.requestSaveCategoryData.name;
    }
  },
  created() {
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.imageBasePath = Config.apiFileBasePath;
    this.getCategoriesWithFilter();
  },
  watch: {
    name(value) {
      // binding this to the data value in the email input
      this.requestSaveCategoryData.name = value;
      this.requestSaveCategoryData.slug = this.requestSaveCategoryData.name.trim().toLocaleLowerCase().replaceAll(' ', '-').replaceAll('/', '-').replace(/[&\\#,+()[/;^!@\]$~%.'":*?<>{}]/g, '');
      if (this.requestSaveCategoryData.name.length > 0) {
        this.msg['name'] = '';
      } else {
        this.msg['name'] = 'Invalid Name';
      }
    },
    filter(data) {
      if (this.prevFilter != data) {
        this.onFiltered();
      }
      return data;
    }
  },
  data() {
    return {
      permissions: {},
      nameBlurred: false,
      fields: [
        {
          key: 'name',
          sortable: true,
          thStyle: {width: "30%"},
          tdClass: "px-3",
          thClass: "px-3",
          formatter: (value) => {
            if (value.length > 100) {
              return value.slice(0, 99) + "...";
            } else {
              return value;
            }
          },
        },
        {
          key: 'slug', thStyle: {width: "30%"}, sortable: false, class: 'text-center', formatter: (value) => {
            if (value.length > 50) {
              return value.slice(0, 49) + "...";
            } else {
              return value;
            }
          },
        },
        {key: 'position', sortable: true, class: 'text-center'},
        {label: 'Type', key: 'view_type', sortable: true, class: 'text-center',},
        {key: 'status', sortable: true, class: 'text-center'},
        {key: 'actions', label: 'Actions', class: 'text-center'},
      ],
      msg: {},
      imageBasePath: null,
      showModalLogo: false,
      submitted: false,
      editEnabled: false,
      loading: false,
      message: sessionStorage.getItem("message"),
      roles: [],
      rolesLoaded: false,
      requestSaveCategoryData: {
        category_id: this.category_id,
        name: "",
        name_en: "",
        description: "",
        public_yn: "Y",
        slug: "",
        view_type: "REGULAR"
      },
      slugEditEnabled: null,
      categories: [],
      // pagination
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 20, 100],
      sortBy: '',
      sortDesc: true,
      sortDirection: 'asc',
      prevFilter: null,
      filter: null,
      // postCategories
    };
  },


  methods: {
    getCategoryImage(imageData) {
      this.requestSaveCategoryData.image_url = imageData.file_path;
    },
    handlePageSizeChange(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.getCategoriesWithFilter();
    },
    async handlePageChange() {
      await this.getCategoriesWithFilter();
    },
    onFiltered() {
      if (this.prevFilter != this.filter) {
        this.currentPage = 1
        this.getCategoriesWithFilter();
        this.prevFilter = this.filter;
      }
    },
    async beginEditing(postData) {
      this.editEnabled = true;
      this.requestSaveCategoryData.id = postData.id;
      this.requestSaveCategoryData.name = postData.name;
      this.requestSaveCategoryData.name_en = postData.name_en;
      this.requestSaveCategoryData.slug = postData.slug;
      this.requestSaveCategoryData.public_yn = postData.public_yn;
      this.requestSaveCategoryData.position = postData.position;
      this.requestSaveCategoryData.image_url = postData.image_url;
      this.requestSaveCategoryData.description = postData.description;
      this.requestSaveCategoryData.view_type = postData.view_type;
    },
    async unpublish(subcategoryId) {
      try {
        const payload = {
          subcategoryId: subcategoryId,
        }
        const response = await subcategoryService.unpublishSubcategory(payload);
        this.loading = false;

        if (response.messageCode === 1) {
          notify({
            type: "success",
            title: "Update Service Category",
            text: response.message,
          });
          await this.getCategoriesWithFilter();

        } else {
          notify({
            type: "error",
            title: "Update Service Category",
            text: response.message,
          });
        }
      } catch (e) {
        notify({
          type: "error",
          title: "Update Service Category",
          text: "Could not unpublish Service Category",
        });
        console.log(e)
      }

    },
    async updateCategory() {
      if (!this.checkValidation()) {
        return;
      }
      this.loading = true;
      this.requestSaveCategoryData.category_id = this.category_id;
      var response;
      try {
        response = await subcategoryService.updateSubCategory(this.requestSaveCategoryData);
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Update Service Category",
          text: error.message,
        });
      }
      this.loading = false;

      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Update Service Category",
            text: response.data.message,
          });
          this.getCategoriesWithFilter();
          this.clearData();
        } else {

          notify({
            type: "error",
            title: "Update Service Category",
            text: response.data.message,
          });
        }
      }
    },
    clearData() {
      this.editEnabled = false;
      this.nameBlurred = false;
      this.requestSaveCategoryData = {
        id: null,
        category_id: this.category_id,
        name: "",
        name_en: "",
        description: "",
        slug: "",
        view_type: "REGULAR"
      };
    },
    titleChanged(value) {
      this.requestSaveCategoryData.name = value;
      this.requestSaveCategoryData.slug = value.replaceAll(' ', '-').replace(/[&\\#,+()[/;^!@\]$~%.'":*?<>{}]/g, '');
    },
    async addCategory() {
      if (!this.checkValidation()) {
        return;
      }
      this.loading = true;
      this.requestSaveCategoryData.category_id = this.category_id;
      const response = await subcategoryService.saveNewSubCategory(this.requestSaveCategoryData);
      this.loading = false;

      if (response.data) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Add Post Category",

            text: response.data.message,
          });
          this.getCategoriesWithFilter();
          this.clearData();
        } else {
          notify({
            type: "error",
            title: "Add Post Category",
            text: response.data.message,
          });
        }
      }
    },
    async getCategories() {
      this.loading = true;
      const response = await subcategoryService.getSubCategoriesByCategoryId(this.category_id);
      this.loading = false;

      if (response.data) {
        this.categories = response.data;
      }
    },
    async getCategoriesWithFilter() {
      this.loading = true;
      const params = {
        'per_page': this.perPage,
        'page': this.currentPage,
        'sort_by': this.sortBy,
        'sort_type': (this.sortDesc) ? 'desc' : 'asc',
        'search': this.filter,
      };
      var response;
      try {
        response = await subcategoryService.getSubCategoriesByCategoryIdWithFilter(this.category_id, params);
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Category Table",
          text: error.response.data.message,
        });
      }
      this.loading = false;
      if (response.data) {
        this.categories = response.data.data.data;
        this.currentPage = response.data.data.current_page;
        this.totalRows = response.data.data.total;
        this.perPage = response.data.data.per_page;
        this.to = response.data.data.to;
      }
    },
    checkValidation() {
      if (!this.nameValidation()) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Name should not be empty!",
        });
        return false;
      }
      if (!this.slugValidation()) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Slug should not be empty!",
        });
        return false;
      }
      if (!this.positionValidation()) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Position should be a valid Integer!",
        });
        return false;
      }
      return true;
    },
    slugValidation() {
      if (this.requestSaveCategoryData.slug == '' || this.requestSaveCategoryData.slug == null) {
        return false;
      } else {
        return true;
      }
    },
    positionValidation() {
      if (this.requestSaveCategoryData.position == "") {
        this.requestSaveCategoryData.position = null;
      }
      if (this.requestSaveCategoryData.position == null) {
        return true;
      } else {
        if (!isNaN(this.requestSaveCategoryData.position) && !isNaN(parseFloat(this.requestSaveCategoryData.position))) {
          this.requestSaveCategoryData.position = parseInt(this.requestSaveCategoryData.position);
          return true;
        }
        // this.requestSaveCategoryData.position = null;
        return false;
      }
    },
    nameValidation() {
      if (this.requestSaveCategoryData.name == '' || this.requestSaveCategoryData.name == null) {
        return false;
      }
      return true;
    }
  },
};
</script>
<style scoped>
.userInputField {
  width: 95%;
  margin-bottom: 10px;
}

.rightBar {
  width: 60%;
  margin-bottom: 10px;
}

.leftBar {
  width: 40%;
  margin-bottom: 10px;
}

.input-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}
</style>